import React from 'react';
import { StaticPage, TopbarContainer } from '../../containers';
import { FormattedMessage } from '../../util/reactIntl';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
  PrimaryButton,
} from '../../components';


import css from './ContactPage.module.css';


const ContactPage = () => {



  return (
    <StaticPage
        title="Nous contacter"
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.mainWrapper}>
            <div className={css.content}>
                <h1>Vous souhaitez nous contacter?</h1>
                <h2> Vous avez une suggestion pour améliorer notre service ou tout simplement une question?</h2>
                
                <PrimaryButton>
                  <a style={{color: "white"}} href="mailto:contact@jardins-prives.com" target="_blank">Contactez-nous</a>
                </PrimaryButton>

                <p>Si vous n'avez pas de messagerie configurée sur votre ordinateur ou votre téléphone, veuillez envoyer votre message à : <a href="mailto:contact@jardins-prives.com">contact@jardins-prives.com</a> </p>

            </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

export default ContactPage;
